export class ApiError extends Error {
  status: number;
  statusText: string;

  constructor(status: number, statusText: string, message: string) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.statusText = statusText;
  }
}

// NOTE: the `[ApiError | null, T | null]` tuple is declared once, in
// `lib/auth/apiClient.ts`. It deliberately has no type-parameter default; a
// second copy here previously gave `T` a default, which would quietly undo that
// guarantee for any file importing it from this (non-`server-only`) module.

// Явный shape для данных, прошедших через RSC-границу.
// Named type — а не анонимная структура — чтобы было видно намерение в сигнатурах.
export interface FrontApiError {
  status: number;
  statusText: string;
  message: string;
}

/**
 * Statuses the new room API uses to say "asking again cannot help": an expired
 * session, a refused permission, a record gone from this room. The query retry
 * policy skips them and the error boundary hides its retry button for them.
 */
export const TERMINAL_API_STATUSES = [401, 403, 404] as const;

export function isTerminalApiStatus(status: number): boolean {
  return (TERMINAL_API_STATUSES as readonly number[]).includes(status);
}

export function getApiErrorMessage(
  error: { status: number },
  fallback: string,
): string {
  switch (error.status) {
    case 401:
      return "Сессия истекла. Войдите снова.";
    case 403:
      return "Недостаточно прав для этого действия или нет доступа к комнате.";
    case 404:
      return "Запись не найдена в этой комнате или уже удалена.";
    default:
      return fallback;
  }
}

export function toFrontApiError(e: ApiError | Error): FrontApiError {
  if (e instanceof ApiError) {
    return { status: e.status, statusText: e.statusText, message: e.message };
  }

  return {
    status: 500,
    statusText: "",
    message: e instanceof Error ? e.message : "Unknown error",
  };
}
